<app-support-mode-banner />

@if (isLoading()) {
  <div class="progress">
    <div class="indeterminate"></div>
  </div>
}

<div class="d-flex flex-direction-column overflow-auto p-16 main-container">
  <router-outlet />
</div>

<app-confirmation-modal />
<app-alert-modal />

@if (terminalParametersMap()[terminalParameterKeys.WEB_CASH_SHOW_TUBE] && isCustomerScreen) {
  <app-tube-overlay-view />
}
